import { GridLogicOperator } from '@mui/x-data-grid-pro';

import TableInstance from '../constants/tableInstance';

export enum LocalStorageKeys {
  Filters = 'filters',
}

type Filters = {
  [key in TableInstance]?: {
    search: {
      [key: string]: {
        value: string;
        op: GridLogicOperator | undefined;
        cop: string[];
      };
    }[];
  };
};

type LocalStorageTypes = {
  [LocalStorageKeys.Filters]: Filters;
};

const localStorageService = {
  setItem<K extends keyof LocalStorageTypes>(
    key: K,
    value: LocalStorageTypes[K],
  ) {
    window.localStorage.setItem(key, JSON.stringify(value));
  },

  getItem<K extends keyof LocalStorageTypes>(
    key: K,
  ): LocalStorageTypes[K] | null {
    const item = window.localStorage.getItem(key);
    return item ? (JSON.parse(item) as LocalStorageTypes[K]) : null;
  },

  removeItem(key: LocalStorageKeys) {
    window.localStorage.removeItem(key);
  },

  clear() {
    window.localStorage.clear();
  },
};

export default localStorageService;
